import React from "react";
import { useTranslation } from "react-i18next";
import "../assets/css/styles.css";

const projects = [
    {
        key: "dental",
        url: "https://odontopediatrapuebla-b28c7.web.app/",
        icon: "🦷",
        color: "#00bcd4",
    },
    {
        key: "deals",
        url: "https://cazaofertasia.web.app/",
        icon: "🤖",
        color: "#7c4dff",
    },
    {
        key: "rifle",
        url: "https://play.google.com/store/apps/details?id=com.KuiraSoft.CalibrarMira&hl=es_419",
        icon: "🎯",
        color: "#ff6d00",
        badge: "⭐ 4.5 · 50K+",
    },
];

const LandingPage = () => {
    const { t, i18n } = useTranslation();

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    };

    return (
        <div className="landing-container">
            <nav className="navbar">
                <a href="/" className="logo">KUIRASOFT</a>
                <div className="nav-links">
                    <a href="#home" className="nav-link">{t('nav.home')}</a>
                    <a href="#history" className="nav-link">{t('nav.history')}</a>
                    <a href="#apps" className="nav-link">{t('nav.apps')}</a>
                </div>
                <div className="lang-switcher">
                    <button
                        className={`lang-btn ${i18n.language === 'en' ? 'active' : ''}`}
                        onClick={() => changeLanguage('en')}>EN</button>
                    <button
                        className={`lang-btn ${i18n.language === 'es' ? 'active' : ''}`}
                        onClick={() => changeLanguage('es')}>ES</button>
                    <button
                        className={`lang-btn ${i18n.language === 'pt' ? 'active' : ''}`}
                        onClick={() => changeLanguage('pt')}>PT</button>
                </div>
            </nav>

            <header id="home" className="hero">
                <h1 dangerouslySetInnerHTML={{ __html: t('hero.title') }}></h1>
                <p>{t('hero.subtitle')}</p>
                <a href="#history" className="btn-primary">{t('hero.learnMoreBtn')}</a>
            </header>

            <section id="history" className="section">
                <h2 className="section-title">{t('history.title')}</h2>
                <p className="section-desc">{t('history.desc')}</p>
            </section>

            {/* Apps / Projects Section */}
            <section id="apps" className="section" style={{ backgroundColor: '#050505' }}>
                <h2 className="section-title">{t('apps.title')}</h2>
                <p className="section-desc" style={{ marginBottom: '4rem' }}>{t('apps.desc')}</p>

                <div className="apps-grid">
                    {projects.map((app) => (
                        <a
                            key={app.key}
                            href={app.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="app-card"
                            style={{ '--card-accent': app.color }}
                        >
                            <div className="app-icon">{app.icon}</div>
                            <h3 className="app-name">{t(`apps.${app.key}.name`)}</h3>
                            <p className="app-desc">{t(`apps.${app.key}.desc`)}</p>
                            {app.badge && (
                                <span className="app-badge">{app.badge}</span>
                            )}
                            <span className="app-cta">{t('apps.viewApp')} →</span>
                        </a>
                    ))}
                </div>
            </section>

            <footer>
                <div className="footer-top">
                    <div className="footer-info">
                        <h3>KUIRASOFT</h3>
                        <p className="section-desc">{t('footer.desc')}</p>
                    </div>
                    <div className="footer-links">
                        <a href="https://play.google.com/store/apps/dev?id=4997040951036356526&hl=es_419" target="_blank" rel="noopener noreferrer" className="footer-link">
                            {t('footer.playstore')}
                        </a>
                        <a href="https://sites.google.com/view/kuirasoft-terms-condit-privacy" target="_blank" rel="noopener noreferrer" className="footer-link">
                            {t('footer.privacy')}
                        </a>
                        <a href="https://www.facebook.com/KuiraSoft/" target="_blank" rel="noopener noreferrer" className="footer-link">
                            {t('footer.facebook')}
                        </a>
                    </div>
                </div>
                <p className="rights">© {new Date().getFullYear()} Kuirasoft. {t('footer.rights')}</p>
            </footer>
        </div>
    );
};

export default LandingPage;
